import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'

import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import moment from 'moment';

import './footer.scss';

class Footer extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    const hotelData = this.props.hotel.loading
                        ? <p>-</p>
                        : <p>{this.props.hotel.apiData.name} | {this.props.hotel.apiData.address}{!!this.props.hotel.apiData.zip ? ` - ${this.props.hotel.apiData.zip}` : null} - {this.props.hotel.apiData.city}</p>

    const hotelContacts = this.props.hotel.loading
                            ? <p>-</p>
                            : <p>
                                {this.props.hotel.apiData.phone ? <a href={`tel:${this.props.hotel.apiData.phone}`}>{this.props.hotel.apiData.phone}</a> : null}
                                {this.props.hotel.apiData.phone && this.props.hotel.apiData.email ? ' | ' : null}
                                {this.props.hotel.apiData.email ? <a href={`mailto:${this.props.hotel.apiData.email}`}>{this.props.hotel.apiData.email}</a> : null}
                              </p>

    let footerClass = "footer-component";
    if(this.props.genericTemplate) footerClass = `${footerClass} footer-component__generic`

    return (
      <Grid className={footerClass}>
        <Row>
          <Col xs={12} className="text-center">
            <a target="_blank" href="https://www.facebook.com/BestWestern.Italia"><img src="https://s3.eu-west-1.amazonaws.com/staticta/customer_journey/facebook.png" alt="Facebook"/></a>
            <a target="_blank" href="http://instagram.com/bestwesternItalia"><img src="https://s3.eu-west-1.amazonaws.com/staticta/customer_journey/instagram.png" alt="Instagram"/></a>
            <a target="_blank" href="https://twitter.com/best_westernITA"><img src="https://s3.eu-west-1.amazonaws.com/staticta/customer_journey/twitter.png" alt="Twitter"/></a>
          </Col>
        </Row>
        <br/>
        <Row>
          <Col xs={12} className="text-center">
            { !!this.props.token ? hotelData : null }
            { !!this.props.token ? hotelContacts : null }
            <p>
              <Link to={`/cookie_policy`}>Cookie Policy</Link>
              &nbsp;|&nbsp;
              <Link to={`/privacy_policy`}>Privacy Policy</Link>
            </p>
            <p>Copyright &copy; {moment().year()} - <a href="https://www.bestwestern.it"><strong>BWH Hotels Italia</strong></a></p>
            {!this.props.genericTemplate && <p>{this.props.translate('shared.footer.hotel_text_communications', { hotel_email: `<a href=mailto:${this.props.hotel.apiData.email}>${this.props.hotel.apiData.email}</a>` })}</p> }
            <p>{this.props.translate('shared.footer.privacy_text_communications', { privacy_email: "<a href=\"mailto:privacy@bestwestern.it?subject=Privacy%20CJ\">privacy@bestwestern.it</a>" })}</p>
            <p>{this.props.translate('shared.footer.ownership')}</p>
            { /* this.props.context == 'hotel' || includes(this.props.location.pathname, 'mail_unsubscribe') ? null : <p><small>{this.props.translate('shared.footer.mail_unsubscribe')} <Link to={`/mail_unsubscribe/${this.props.token}`}>{this.props.translate('shared.footer.mail_unsubscribe_link')}</Link></small></p> */ }
          </Col>
        </Row>
      </Grid>
    );
  }
}

Footer.displayName = 'SharedFooter';
Footer.propTypes = {};
Footer.defaultProps = {};

const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    // template: state.hotel.apiData.template,
    hotel: state.hotel,
    token: state.commons.token,
    context: state.commons.context,
    location: state.router.location
  };
};

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./components/shared/Footer.js